import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { WhereToBuyHero } from "@/components/site/wheretobuy/WhereToBuyHero";
import { MarketFinder } from "@/components/site/wheretobuy/MarketFinder";
import { CsaSection } from "@/components/site/wheretobuy/CsaSection";
import { WfButton } from "@/components/site/primitives";
import { SiteFooter } from "@/components/site/SiteFooter";

/**
 * WhereToBuyPage — interactive markets / CSA finder.
 * NOTE: content is PLACEHOLDER/filler for design-demo purposes (see content/whereToBuy.js).
 */
export default function WhereToBuyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader overlay linkToHome />
      <main id="content" tabIndex={-1} className="outline-none">
        <WhereToBuyHero />
        <MarketFinder />
        <CsaSection />

        {/* Closing band */}
        <section aria-labelledby="wtb-outro-heading" className="bg-[var(--wf-cream)] py-16 sm:py-20 lg:py-24">
          <div className="wf-container">
            <div className="relative overflow-hidden rounded-sm bg-[var(--wf-maroon)] px-6 py-14 text-center sm:px-10 sm:py-16">
              <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[var(--wf-clay)]/30 blur-2xl" />
              <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 -left-10 h-64 w-64 rounded-full bg-[var(--wf-wheat)]/20 blur-2xl" />
              <div className="relative mx-auto max-w-2xl">
                <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[rgba(255,253,248,0.85)]">Grow with us</span>
                <h2 id="wtb-outro-heading" className="mt-4 font-serif text-3xl font-semibold leading-[1.1] text-white sm:text-4xl">Want to sell your crops, or partner as a buyer?</h2>
                <p className="mx-auto mt-4 max-w-xl text-base leading-7 text-[rgba(255,253,248,0.85)]">Farmers, grocers, and restaurants are all welcome. Reach out and we'll help you get connected.</p>
                <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                  <WfButton as={Link} to="/support" variant="light" withArrow className="px-7" data-testid="wtb-outro-cta-button">Get Involved</WfButton>
                  <WfButton as="a" href="/" className="border border-white/60 bg-white/10 px-7 text-white backdrop-blur-sm hover:bg-white/20" data-testid="wtb-outro-home-button">Back to home</WfButton>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
